export default __webpack_public_path__ + "static/media/09.3f4aed03.png";